import React from 'react';
import {
	ComposableMap,
	Geographies,
	Geography,
	Marker,
} from 'react-simple-maps';
import { useTheme } from 'next-themes';

// Use local TopoJSON file instead of remote URL
const geoUrl = '/worldmap.json';

export interface ImpactMarker {
	name: string;
	coordinates: [number, number]; // [longitude, latitude}
	description?: string;
}

interface WorldImpactMapProps {
	markers: ImpactMarker[];
}

const WorldImpactMap: React.FC<WorldImpactMapProps> = ({ markers }) => {
	const { resolvedTheme } = useTheme();
	const isDark = resolvedTheme === 'dark';

	return (
		<section className='hidden md:block py-8 px-4 bg-white dark:bg-gray-900'>
			<div className='max-w-6xl mx-auto'>
				<h2 className='text-4xl font-bold text-center mb-12'>
					Where we've made{' '}
					<span className='text-[rgb(251,176,64)]'>impact</span>.
				</h2>

				<div className='relative w-full h-[400px] sm:h-[500px] md:h-[600px]'>
					<ComposableMap
						projection='geoEqualEarth'
						projectionConfig={{
							scale: 180,
						}}
						style={{
							width: '100%',
							height: '100%',
						}}
					>
						<Geographies geography={geoUrl}>
							{({ geographies }) =>
								geographies.map((geo) => (
									<Geography
										key={geo.rsmKey}
										geography={geo}
										fill={isDark ? '#1e293b' : '#8F9FA3'}
										stroke={isDark ? '#334155' : '#FFFF'}
										strokeWidth={0.5}
										style={{
											default: { outline: 'none' },
											hover: { outline: 'none' },
											pressed: { outline: 'none' },
										}}
									/>
								))
							}
						</Geographies>

						{markers.map(({ name, coordinates }) => (
							<Marker key={name} coordinates={coordinates}>
								{/* Larger base marker */}
								<circle
									r={5}
									fill='#fbb040'
									stroke={isDark ? '#0f172a' : '#ffffff'}
									strokeWidth={2}
								/>
								{/* Pulsating outer circle */}
								<circle
									r={5}
									fill='#fbb040'
									fillOpacity={0.5}
									stroke='none'
									className='pulse-circle'
								/>
								<title>
									{name}
									{/* {description ? `: ${description}` : ''} */}
								</title>
							</Marker>
						))}
					</ComposableMap>
				</div>
			</div>
		</section>
	);
};

export default WorldImpactMap;
